[
  "dark",
  "jenny",
  "mana-white",
  "mana-blue",
  "mana-black",
  "mana-red",
  "mana-green",
  "mana-colorless"
]
